import { createSelector } from '@reduxjs/toolkit';
import { TenantDomainId } from '../pageConfig';

export interface TenantConfig {
  id: TenantDomainId;
  outputName: string;
  brandHubId: string;
  copyright: string;
  support: {
    privacyEmail: string;
    techSupportEmail: string;
    customerServiceEmail: string;
  };
}

export const selectTenantConfig = createSelector(
  [(state) => state.pageConfig.tenantConfig as TenantConfig],
  (data) => data,
);
